module.exports = __webpack_public_path__ + "static/media/icon-divulgacao.34c189c9.svg";